var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { changeBetAmount as changeBetAmountAction } from '../../actions/coupon/creators/coupon';
var StakeVariants = /** @class */ (function (_super) {
    __extends(StakeVariants, _super);
    function StakeVariants() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.changeAmount = function (value, e) {
            if (!_this.props.freebetToggled) {
                _this.props.changeBetAmountAction(value);
            }
        };
        return _this;
    }
    StakeVariants.prototype.render = function () {
        var favoriteAmounts = this.props.favoriteAmounts;
        var favourite_1 = this.changeAmount.bind(this, favoriteAmounts.get('favorite_1'));
        var favourite_2 = this.changeAmount.bind(this, favoriteAmounts.get('favorite_2'));
        var favourite_3 = this.changeAmount.bind(this, favoriteAmounts.get('favorite_3'));
        var favourite_4 = this.changeAmount.bind(this, favoriteAmounts.get('favorite_4'));
        var favStateIsToggled = JSON.parse(localStorage.getItem('toggledFavStake'));
        return (favStateIsToggled &&
            _jsxs("div", __assign({ className: 'stake-variants' }, { children: [_jsx("span", __assign({ className: 'favourite-bet-1 stake-amount', onClick: favourite_1 }, { children: favoriteAmounts.get('favorite_1') })), _jsx("span", __assign({ className: 'favourite-bet-2 stake-amount centered', onClick: favourite_2 }, { children: favoriteAmounts.get('favorite_2') })), _jsx("span", __assign({ className: 'favourite-bet-3 stake-amount', onClick: favourite_3 }, { children: favoriteAmounts.get('favorite_3') })), _jsx("span", __assign({ className: 'favourite-bet-4 stake-amount', onClick: favourite_4 }, { children: favoriteAmounts.get('favorite_4') }))] })));
    };
    return StakeVariants;
}(React.Component));
StakeVariants.propTypes = {
    freebetToggled: PropTypes.bool.isRequired,
    changeBetAmountAction: PropTypes.func.isRequired,
    favoriteAmounts: PropTypes.object.isRequired,
};
var mapStateToProps = function (state) { return ({
    favoriteAmounts: state.application.get('favoriteAmounts')
}); };
var mapDispatchToProps = function (dispatch) { return bindActionCreators({
    changeBetAmountAction: changeBetAmountAction
}, dispatch); };
StakeVariants = connect(mapStateToProps, mapDispatchToProps)(StakeVariants);
export default StakeVariants;



// WEBPACK FOOTER //
// ./src/components/coupon/StakeVariants.js